export default __webpack_public_path__ + "static/media/logo.768f8829.png";